import { CButton } from "@coreui/react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { useState } from "react";

const PDFDownloadButton = ({ file, fileName }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      // Handle both cases where file is a URL string or a Blob/File object
      let blobData = null;

      if (typeof file === "string") {
        // If file is a URL, fetch it first
        const response = await fetch(file);
        blobData = await response.blob();
      } else {
        // If file is already a Blob or File object
        blobData = file;
      }

      // Create a blob URL from the data
      const url = URL.createObjectURL(blobData);

      // Use the provided fileName or generate a default one
      const downloadFileName = fileName || "document.pdf";

      // Create a temporary anchor element to trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = downloadFileName;
      document.body.appendChild(a);
      a.click();

      // Clean up
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <CButton
      color="primary"
      size="sm"
      data-testid="report-btn-pdf-download"
      data-attr="reports:btn:download-pdf"
      onClick={handleDownload}
      disabled={isDownloading}
      style={{ display: "flex", alignItems: "center", gap: "5px" }}
    >
      <FaDownload />
      {isDownloading ? "Downloading..." : "Download"}
    </CButton>
  );
};

PDFDownloadButton.propTypes = {
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  fileName: PropTypes.string,
};

export default PDFDownloadButton;
